import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import { useTranslation } from "react-i18next";
import {
  getLogisticaPedidoChipLabel,
  getLogisticaPedidoLinkId,
  getPedidoClienteLabel,
  getPedidoSupplierLabel,
} from "./logisticaUtils";

const EnvioPedidoNameChip = ({
  lnk,
  onUnlink,
  onOpenEnvios,
  hasMixedClientes = false,
  hasMixedSuppliers = false,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const idPed = getLogisticaPedidoLinkId(lnk);
  const label = getLogisticaPedidoChipLabel(lnk);
  const pedido = lnk?.pedidoA3;
  const tooltipParts = [
    hasMixedClientes ? getPedidoClienteLabel(pedido) : "",
    hasMixedSuppliers ? getPedidoSupplierLabel(pedido) : "",
    onOpenEnvios ? t("logisticaPedidos.nuevoEnvioChipHint") : "",
  ].filter(Boolean);

  const stop = (event) => {
    event.stopPropagation();
  };

  const chip = (
    <Chip
      size="small"
      label={label}
      onClick={
        onOpenEnvios
          ? (event) => {
              stop(event);
              onOpenEnvios(lnk);
            }
          : undefined
      }
      onDelete={
        idPed && onUnlink
          ? (event) => {
              stop(event);
              onUnlink({ idPedido: idPed, label });
            }
          : undefined
      }
      deleteIcon={
        <Tooltip title={t("logisticaPedidos.unlink")}>
          <LinkOffIcon fontSize="small" />
        </Tooltip>
      }
      sx={{
        cursor: onOpenEnvios ? "pointer" : "default",
        fontWeight: 700,
        maxWidth: "100%",
        backgroundColor: alpha(theme.palette.info.main, 0.1),
        color: theme.palette.info.main,
        border: "1px solid",
        borderColor: alpha(theme.palette.info.main, 0.22),
        "& .MuiChip-label": {
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      }}
    />
  );

  if (!tooltipParts.length) return chip;
  return <Tooltip title={tooltipParts.join(" · ")}>{chip}</Tooltip>;
};

export default EnvioPedidoNameChip;
